import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubHeader]'})
export class HeaderDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
